import React from 'react';
import classNames from 'classnames';
import { formatNumber } from './../../utils/dyzio';

const SocialBar = ({ item }) => {
  const computeWidth = (total, value) => total < 1 ? '0%' : `${(value / total) * 100}%`;

  const line = () => {
    const objects = Object.keys(item.data || {});
    const total = objects.reduce((current, key) => current + (item.data[key] || 0), 0);
    return objects.map(part => (
      <div className="social-bar-item" style={{ width: computeWidth(total, item.data[part] || 0) }} key={part.influencer + part}>
        <div className={['social-line', part].join(' ')} />
      </div>
    ));
  };

  const labels = () => Object.keys(item.data || {}).map((label) => {
    const classes = classNames(['social-item-label', label, {'inactive': !item.data[label]}]);
    const number = item.data[label] || 0;
    return (
      <div className={classes} key={['item.influencer', label].join('')}>
        { formatNumber(number) }
      </div>
    );
  });

  return (
    <div className="social-bar">
      {line()}
      {labels()}
    </div>
  );
};

SocialBar.propTypes = {
  item: React.PropTypes.object.isRequired,
};

export default SocialBar;



// WEBPACK FOOTER //
// ./src/components/social-bar/index.js